import { toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import type { UserModel } from '@models/types'

const defaultState = {
  filterString: '',
  message: '',
  selectedUsers: [] as UserModel[],
}

type SetState = (state: Partial<typeof defaultState>) => void

type ToggleSelectedUserParams = {
  selectedUsers: UserModel[],
  setState: SetState,
  user: UserModel,
}

const toggleSelectedUser = (params: ToggleSelectedUserParams) => {
  const { selectedUsers, setState, user } = params

  const updatedSelectedUsers = toggleArray(selectedUsers, user, { deepCompare: true })
  setState({ selectedUsers: updatedSelectedUsers })
}

const useShareProjectModal = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    filterString, message, selectedUsers,
  } = state

  const hasSelectedUsers = !!selectedUsers.length
  const selectedUsersCount = selectedUsers.length

  return {
    callbacks: {
      setModalState: (values: Partial<typeof defaultState>) => setState(values),
      toggleUser: (user: UserModel) => toggleSelectedUser({ selectedUsers, setState, user }),
    },
    filterString,
    hasSelectedUsers,
    message,
    selectedUsers,
    selectedUsersCount,
  }
}

export type useShareProjectModalPayload = ReturnType<typeof useShareProjectModal>

export default useShareProjectModal
